import { BaseService } from "./BaseService";
import { FunctionGroup, MeasuresType } from "../types/app.enums";
import { Measures } from "../types/app.interfaces";

export class PooledBenchmarkPhase2UnivService extends BaseService {
  burgissCalcPooledBenchmarkDPIByWeight(
    universe: string = null,
    weight: string = null,
    currency?: string,
    alternateCurrrency?: string,
    endDate?: any,
    weightingMethod: any = null,
    requireReportedValuation?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      universe,
      weight,
      null,
      currency,
      alternateCurrrency,
      endDate,
      weightingMethod,
      requireReportedValuation,
      MeasuresType.DPI,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissCalcPooledBenchmarkDPIByWeight",
      objRequest,
      this.APICONFIG.GETPORTFOLIOBENCHMARKUNIV,
      FunctionGroup.Pooledbenchmarkphase2Univ
    );
  }
  burgissCalcPooledBenchmarkTVPIByWeight(
    universe: string = null,
    weight: string = null,
    currency?: string,
    alternateCurrrency?: string,
    endDate?: any,
    weightingMethod: any = null,
    requireReportedValuation?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      universe,
      weight,
      null,
      currency,
      alternateCurrrency,
      endDate,
      weightingMethod,
      requireReportedValuation,
      MeasuresType.TVPI,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissCalcPooledBenchmarkTVPIByWeight",
      objRequest,
      this.APICONFIG.GETPORTFOLIOBENCHMARKUNIV,
      FunctionGroup.Pooledbenchmarkphase2Univ
    );
  }
  burgissCalcPooledBenchmarkRVPIByWeight(
    universe: string = null,
    weight: string = null,
    currency?: string,
    alternateCurrrency?: string,
    endDate?: any,
    weightingMethod: any = null,
    requireReportedValuation?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      universe,
      weight,
      null,
      currency,
      alternateCurrrency,
      endDate,
      weightingMethod,
      requireReportedValuation,
      MeasuresType.RVPI,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissCalcPooledBenchmarkRVPIByWeight",
      objRequest,
      this.APICONFIG.GETPORTFOLIOBENCHMARKUNIV,
      FunctionGroup.Pooledbenchmarkphase2Univ
    );
  }
  burgissCalcPooledBenchmarkDPIByCommitment(
    universe: string = null,
    commitment: string = null,
    currency?: string,
    alternateCurrrency?: string,
    endDate?: any,
    weightingMethod: any = null,
    requireReportedValuation?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      universe,
      null,
      commitment,
      currency,
      alternateCurrrency,
      endDate,
      weightingMethod,
      requireReportedValuation,
      MeasuresType.DPI,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissCalcPooledBenchmarkDPIByCommitment",
      objRequest,
      this.APICONFIG.GETPORTFOLIOBENCHMARKUNIV,
      FunctionGroup.Pooledbenchmarkphase2Univ
    );
  }
  burgissCalcPooledBenchmarkTVPIByCommitment(
    universe: string = null,
    commitment: string = null,
    currency?: string,
    alternateCurrrency?: string,
    endDate?: any,
    weightingMethod: any = null,
    requireReportedValuation?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      universe,
      null,
      commitment,
      currency,
      alternateCurrrency,
      endDate,
      weightingMethod,
      requireReportedValuation,
      MeasuresType.TVPI,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissCalcPooledBenchmarkTVPIByCommitment",
      objRequest,
      this.APICONFIG.GETPORTFOLIOBENCHMARKUNIV,
      FunctionGroup.Pooledbenchmarkphase2Univ
    );
  }
  burgissCalcPooledBenchmarkRVPIByCommitment(
    universe: string = null,
    commitment: string = null,
    currency?: string,
    alternateCurrrency?: string,
    endDate?: any,
    weightingMethod: any = null,
    requireReportedValuation?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      universe,
      null,
      commitment,
      currency,
      alternateCurrrency,
      endDate,
      weightingMethod,

      requireReportedValuation,
      MeasuresType.RVPI,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissCalcPooledBenchmarkRVPIByCommitment",
      objRequest,
      this.APICONFIG.GETPORTFOLIOBENCHMARKUNIV,
      FunctionGroup.Pooledbenchmarkphase2Univ
    );
  }

  createPayload(
    universe: string = null,
    weight: string = null,
    commitment: string = null,
    baseCurrency?: any,
    alternateCurrrency?: string,
    endDate?: any,
    weightingMethod: any = null,
    requireReportedValuation?: any,
    measure: string = null,
    alias: string = null
  ) {
    const PooledbenchmarkUnivObject: Measures = {
      excludeBalanceSheetItems: false,
      excludeUndisclosedItems: false,
      excludeUnknownEntities: false,
      excludeRealizationsPriorToClosingDate: null,
      financeIndexID: null,
      financePremium: null,
      reinvestmentIndexID: null,
      reinvestmentPremium: null,
      forceRollForward: null,
      peergroupID: null,
      percentile: null,
      currency: null,
      returnConstituentCount: false,
      investmentID: "-1",
      portfolioID: "0",
      isHoldingCalc: false,
      returnPooledResult: true,
      baseCurrency: String(baseCurrency).toLowerCase() === "true",
      alternateBaseCurrency: alternateCurrrency,
      adjustToMostRecent: false,
      measure: measure,
      beginDate: null,
      endDate: endDate,
      year: null,
      indexID: "",
      premium: null,
      idType: "i",
      selectionsetID: "",
      assetID: null,
      weightingMethod: weightingMethod,
      value: null,
      filter: "",
      attributeName: null,
      rankValue: null,
      bMUHistoricalWindowLengthQtrs: 0,
      maxAgeDiffYears: null,
      horizon: null,
      maxDroppedPeriods: null,
      lastHistoricalEOQDate: null,
      numSimulations: null,
      desiredSampleSize: null,
      minSampleSize: null,
      sampleStatistic: null,
      stopOn: null,
      requireReportedValuation: requireReportedValuation,
      alias: alias,
      currencyHedgesetId: "",
      foFLookThrough: false,
      useReceivedDate: false,
      excludeFrozenAsset: true,
      useAlternateFundSize: false,
      dynamicParameter: null,
      universe: universe,
      weight: String(weight).toUpperCase() == "NULL" ? "" : String(weight),
      commitment: String(commitment).toUpperCase() == "NULL" ? "" : String(commitment),
    };
    return PooledbenchmarkUnivObject;
  }
}
